// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  background-color: #1E2D3D;
  color: white;
  padding-top: 4rem;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem 3rem;
  display: flex;
  flex-wrap: wrap;
}

.footer-logo-section {
  flex: 1 1;
  min-width: 300px;
  margin-bottom: 2rem;
}

.footer-logo-section h2 {
  font-size: 1.8rem;
  margin: 0 0 1rem;
  color: #9945FF;
}

.footer-logo-section p {
  color: #ccc;
  margin-bottom: 1.5rem;
  max-width: 300px;
  line-height: 1.6;
}

.social-links {
  display: flex;
  gap: 1rem;
}

.social-link {
  color: white;
  text-decoration: none;
  transition: color 0.3s ease;
  padding: 0.5rem;
}

.social-link:hover {
  color: #9945FF;
}

.footer-links-section {
  flex: 2 1;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.footer-links-column {
  min-width: 200px;
  margin-bottom: 2rem;
  padding-right: 1rem;
}

.footer-links-column h3 {
  font-size: 1.2rem;
  margin: 0 0 1.5rem;
  color: #9945FF;
  position: relative;
}

.footer-links-column h3::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 0;
  width: 40px;
  height: 3px;
  background-color: #9945FF;
}

.footer-links-column ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-links-column li {
  margin-bottom: 0.8rem;
}

.footer-links-column a {
  color: #ccc;
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-links-column a:hover {
  color: #9945FF;
}

/* WeChat QR Code Styles */
.wechat-qr {
  margin-top: 1.5rem;
}

.wechat-qr p {
  color: #ccc;
  margin-bottom: 0.8rem;
}

.wechat-qr-image {
  max-width: 120px;
  border: 2px solid #9945FF;
  border-radius: 6px;
}

.footer-bottom {
  background-color: #18242f;
  padding: 1.5rem 2rem;
  text-align: center;
}

.footer-bottom p {
  margin: 0;
  color: #888;
  font-size: 0.9rem;
}

@media (max-width: 768px) {
  .footer-container {
    flex-direction: column;
    padding: 0 1rem 2rem;
  }
  
  .footer-links-section {
    flex-direction: column;
  }
  
  .footer-links-column {
    margin-bottom: 2rem;
    width: 100%;
  }

  .wechat-qr-image {
    max-width: 100px;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/Footer.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".footer {\n  background-color: #1E2D3D;\n  color: white;\n  padding-top: 4rem;\n}\n\n.footer-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 2rem 3rem;\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.footer-logo-section {\n  flex: 1;\n  min-width: 300px;\n  margin-bottom: 2rem;\n}\n\n.footer-logo-section h2 {\n  font-size: 1.8rem;\n  margin: 0 0 1rem;\n  color: #9945FF;\n}\n\n.footer-logo-section p {\n  color: #ccc;\n  margin-bottom: 1.5rem;\n  max-width: 300px;\n  line-height: 1.6;\n}\n\n.social-links {\n  display: flex;\n  gap: 1rem;\n}\n\n.social-link {\n  color: white;\n  text-decoration: none;\n  transition: color 0.3s ease;\n  padding: 0.5rem;\n}\n\n.social-link:hover {\n  color: #9945FF;\n}\n\n.footer-links-section {\n  flex: 2;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n\n.footer-links-column {\n  min-width: 200px;\n  margin-bottom: 2rem;\n  padding-right: 1rem;\n}\n\n.footer-links-column h3 {\n  font-size: 1.2rem;\n  margin: 0 0 1.5rem;\n  color: #9945FF;\n  position: relative;\n}\n\n.footer-links-column h3::after {\n  content: '';\n  position: absolute;\n  bottom: -8px;\n  left: 0;\n  width: 40px;\n  height: 3px;\n  background-color: #9945FF;\n}\n\n.footer-links-column ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.footer-links-column li {\n  margin-bottom: 0.8rem;\n}\n\n.footer-links-column a {\n  color: #ccc;\n  text-decoration: none;\n  transition: color 0.3s ease;\n}\n\n.footer-links-column a:hover {\n  color: #9945FF;\n}\n\n/* WeChat QR Code Styles */\n.wechat-qr {\n  margin-top: 1.5rem;\n}\n\n.wechat-qr p {\n  color: #ccc;\n  margin-bottom: 0.8rem;\n}\n\n.wechat-qr-image {\n  max-width: 120px;\n  border: 2px solid #9945FF;\n  border-radius: 6px;\n}\n\n.footer-bottom {\n  background-color: #18242f;\n  padding: 1.5rem 2rem;\n  text-align: center;\n}\n\n.footer-bottom p {\n  margin: 0;\n  color: #888;\n  font-size: 0.9rem;\n}\n\n@media (max-width: 768px) {\n  .footer-container {\n    flex-direction: column;\n    padding: 0 1rem 2rem;\n  }\n  \n  .footer-links-section {\n    flex-direction: column;\n  }\n  \n  .footer-links-column {\n    margin-bottom: 2rem;\n    width: 100%;\n  }\n\n  .wechat-qr-image {\n    max-width: 100px;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
